export enum SharedEndPoints {
    GET_COMPANY_DETAILS = 'GetTextData/CompanyDetails_',
    GET_MENU_OPTIONS = 'GetTextData/AppMenus_',
    GET_AUTHENTICATION_SETTINGS = 'GetTextData/AuthenticationSettings_',
    GET_APP_THEME = 'GetTextData/AppTheme_',
    GET_APPLICATION_LIST = 'GetTextData/ApplicationList_',
    GET_GLOBAL_APP_IMAGE = 'GetTextData/GlobalAppImages_',
    GET_PUSH_NOTIFICAITONS = 'GetTextData/PushNotifications_',
    GET_BINARY_DATA = 'GetBinaryData/',
    GET_NOTIFICATION_LIST = 'GetTextData/NotificationList_',
    SAVE_TEXT_DATA = 'SaveTextData',
    SAVE_BINARY_DATA = 'SaveBinaryData',
    GET_TEXT_DATA = 'GetTextData/AppSettings_',
    SAVE_ANNOUNCEMENT = 'SaveNotification',
    UPDATE_ANNOUNCEMENT = 'UpdateNotification',
    CHANGE_PASSWORD = 'ChangeUserPassword'
}

export enum SharedReactQueryKey {
    GET_COMPANY_DETAILS = 'GET_COMPANY_DETAILS_BYUSER',
    GET_MENU_OPTIONS = 'GET_MENU_OPTIONS',
    GET_AUTHENTICATION_SETTINGS = 'GET_AUTHENTICATION_SETTINGS',
    GET_APP_THEME = 'GET_APP_THEME',
    GET_APPLICATION_LIST = 'GET_APPLICATION_LIST',
    GET_GLOBAL_APP_IMAGE = 'GET_GLOBAL_APP_IMAGE',
    GET_PUSH_NOTIFICAITONS = 'GET_PUSH_NOTIFICAITONS',
    GET_BINARY_DATA = 'GET_BINARY_DATA',
    GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST',
    SAVE_TEXT_DATA = 'SAVE_TEXT_DATA',
    SAVE_BINARY_DATA = 'SAVE_BINARY_DATA',
    GET_TEXT_DATA = 'GET_TEXT_DATA',
    SAVE_ANNOUNCEMENT = 'SAVE_ANNOUNCEMENT',
    UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT',
    CHANGE_PASSWORD = 'CHANGE_PASSWORD'
}
